<div class="row text-center">
    <div class="col-lg-4 col-md-4 col-sm-4">
        <div class="btn-group" role="group">
            <button type="button" class="btn btn-primary"                   
                    (click)="decrement()"
                    [disabled]="prevBtnDisabled">
                <i class="modus-icons align-bottom">triangle_left</i>
            </button>
            <button type="button" class="btn btn-outline-secondary"
                    (click)="today()">
                Today
            </button>
            <button type="button" class="btn btn-primary"                   
                    (click)="increment()"
                    [disabled]="nextBtnDisabled">
                <i class="modus-icons align-bottom">triangle_right</i>
            </button>
        </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-5">
        <h3>{{ viewDate | calendarDate: view + 'ViewTitle':locale }}</h3>
    </div>
</div>
<br />
<ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="cal-cell-top">
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>
</ng-template>
<mwl-calendar-month-view [viewDate]="viewDate"
                         [refresh]="refresh"
                         [events]="events" 
                         (beforeViewRender)="beforeMonthViewRender($event)"
                         [activeDayIsOpen]="activeDayIsOpen"
                         (dayClicked)="dayClicked($event.day)" 
                         [cellTemplate]="customCellTemplate"
                         [excludeDays]="excludeDays">
</mwl-calendar-month-view>